import { DEFAULT_ARDOQ_I18NLOCALE, type I18nLocale, t } from '@ardoq/i18n';

export const UNSET_VALUE_LABEL = 'Not set';

export const getUnsetValueLabel = (
  i18nLocale: I18nLocale = DEFAULT_ARDOQ_I18NLOCALE
): string => t(i18nLocale, 'renderers:unsetValueLabel', UNSET_VALUE_LABEL);

export const getCheckedValueLabel = (
  i18nLocale: I18nLocale = DEFAULT_ARDOQ_I18NLOCALE
): string => t(i18nLocale, 'renderers:scopeData.checkbox.checked', 'Checked');

export const getUncheckedValueLabel = (
  i18nLocale: I18nLocale = DEFAULT_ARDOQ_I18NLOCALE
): string =>
  t(i18nLocale, 'renderers:scopeData.checkbox.unchecked', 'Unchecked');
